import {
   faAngleDown,
   faAngleUp,
   faUser,
} from '@fortawesome/free-solid-svg-icons';
import {
   faAnalytics,
   faBars,
   faChevronSquareLeft,
   faChevronSquareRight,
   faCog,
   faFile,
   faFolder,
   faFolderOpen,
   faMinus,
   faSignOutAlt,
} from '@fortawesome/pro-duotone-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
   AppBar,
   Box,
   Breadcrumbs,
   Collapse,
   Divider,
   Drawer,
   IconButton,
   List,
   ListItem,
   ListItemIcon,
   ListItemText,
   Menu,
   MenuItem,
   Toolbar,
   Typography,
} from '@material-ui/core';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import clsx from 'clsx';
import React, { Fragment, useState, useEffect, useContext } from 'react';
import { Link, useHistory, useLocation } from 'react-router-dom';
import { menu_mock } from '../../mockdata/menu/menu';
import { Layout } from '../../configs/ui/constant';
import Copyright from '../Copyright/Copyright';
import DarkModeToggle from 'react-dark-mode-toggle';
import Loading from '../Loading/Loading';
import Axios from 'axios';
import { useSnackbar } from 'notistack';
import Dialog from './../../components/Modal/General/Message';
import { useOktaAuth } from '@okta/okta-react';

const setIcon = (ref) => {
   switch (ref) {
      case 'main-01':
         return faAnalytics;
      default:
         return faFile;
   }
};

const drawerWidth = 350;

const useStyles = makeStyles((theme) => ({
   root: {
      display: 'flex',
   },
   appBar: {
      transition: theme.transitions.create(['margin', 'width'], {
         easing: theme.transitions.easing.sharp,
         duration: theme.transitions.duration.leavingScreen,
      }),
   },
   appBarShift: {
      width: `calc(100% - ${drawerWidth}px)`,
      marginLeft: drawerWidth,
      transition: theme.transitions.create(['margin', 'width'], {
         easing: theme.transitions.easing.easeOut,
         duration: theme.transitions.duration.enteringScreen,
      }),
   },
   menuButton: {
      marginRight: theme.spacing(2),
   },
   hide: {
      display: 'none',
   },
   drawer: {
      width: drawerWidth,
      flexShrink: 0,
      fontSize: '1.2rem',
   },
   drawerPaper: {
      width: drawerWidth,
   },
   drawerHeader: {
      display: 'flex',
      alignItems: 'left',
      padding: theme.spacing(0, 2),
      // necessary for content to be below app bar
      // ...theme.mixins.toolbar,
      justifyContent: 'center',
      flexDirection: 'column',
      height: '128px',
   },
   drawerHeader2: {
      display: 'flex',
      alignItems: 'center',
      padding: theme.spacing(0, 1),
      // necessary for content to be below app bar
      ...theme.mixins.toolbar,
      justifyContent: 'flex-end',
   },
   content: {
      flexGrow: 1,
      padding: theme.spacing(3),
      transition: theme.transitions.create('margin', {
         easing: theme.transitions.easing.sharp,
         duration: theme.transitions.duration.leavingScreen,
      }),
      marginLeft: -drawerWidth,
   },
   contentShift: {
      transition: theme.transitions.create('margin', {
         easing: theme.transitions.easing.easeOut,
         duration: theme.transitions.duration.enteringScreen,
      }),
      marginLeft: 0,
   },
   nested: {
      paddingLeft: theme.spacing(4),
   },
   active: {
      color: Layout.primary,
   },
   menuBar: {
      display: 'flex',
      justifyContent: 'space-between',
   },
   mainContent: {
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
      minHeight: '100vh',
   },
   footer: {
      padding: theme.spacing(1, 2),
      marginTop: 'auto',
      backgroundColor:
         theme.palette.type === 'light'
            ? theme.palette.grey[200]
            : theme.palette.grey[800],
      transition: theme.transitions.create('margin', {
         easing: theme.transitions.easing.sharp,
         duration: theme.transitions.duration.leavingScreen,
      }),
      marginLeft: -drawerWidth,
   },
   footerShift: {
      padding: theme.spacing(1, 2),
      marginTop: 'auto',
      backgroundColor:
         theme.palette.type === 'light'
            ? theme.palette.grey[200]
            : theme.palette.grey[800],
      transition: theme.transitions.create('margin', {
         easing: theme.transitions.easing.easeOut,
         duration: theme.transitions.duration.enteringScreen,
      }),
      marginLeft: 0,
   },
}));

const MainLayout = ({ onToggleDark, ...props }) => {
   const classes = useStyles();
   const theme = useTheme();
   const location = useLocation();
   const history = useHistory();
   const [info, setInfo] = useState(null);
   const [sideMenu, setSideMenu] = useState(null);
   const [open, setOpen] = useState(true);
   const [myCollapse, setMyCollapse] = useState(menu_mock.menuOpen);
   const [myMenu, setMyMenu] = useState(null);
   const { enqueueSnackbar, closeSnackbar } = useSnackbar();
   const [dialog, setDialog] = useState(false);

   useEffect(() => {
      getUserProfile().then((result) => {
         setInfo(result);
      });
      getMenuList().then((result) => {
         setSideMenu(result.menuList);
      });
   }, []);

   useEffect(() => {
      if (location && sideMenu) {
         let foundInsideMenu = null;
         let pathname = location.pathname.replace('/private', '');
         sideMenu.forEach((el) => {
            if (el.path === pathname) {
               foundInsideMenu = el;
               return;
            } else {
               el.subPath.forEach((subPath) => {
                  if (subPath.path === pathname) {
                     foundInsideMenu = subPath;
                     return;
                  }
               });
            }
         });

         if (foundInsideMenu) {
            validatePermission(foundInsideMenu.permissionId)
               .then((resp) => {
                  if (!resp.isEnable) {
                     enqueueSnackbar('ไม่สามารถเข้าถึงเมนูนี้ได้', {
                        variant: 'error',
                     });
                     setDialog(true);
                  }
               })
               .catch((error) => {
                  handleLogout();
               });
         } else {
            enqueueSnackbar('ไม่พบเมนูนี้', { variant: 'error' });
            setDialog(true);
         }
      }
   }, [location, sideMenu]);

   const getUserProfile = () => {
      return new Promise((resolve, reject) => {
         Axios.get('/GSB/dashboard/user/GetUserInfo')
            .then((response) => {
               resolve(response.data);
            })
            .catch((error) => {
               reject(error);
            });
      });
   };
   const getMenuList = () => {
      return new Promise((resolve, reject) => {
         Axios.get('/GSB/dashboard/user/GetAvailableMenu')
            .then((response) => {
               resolve(response.data);
            })
            .catch((error) => {
               reject(error);
            });
      });
   };
   const validatePermission = (permissionId) => {
      return new Promise((resolve, reject) => {
         Axios.get('/GSB/dashboard/permission/ValidatePermission', {
            params: { permissionId },
         })
            .then((response) => {
               resolve(response.data);
            })
            .catch((error) => {
               reject(error);
            });
      });
   };

   const handleMyMenuClick = (e) => {
      setMyMenu(e.currentTarget);
   };
   const handleMyMenuClose = () => {
      setMyMenu(null);
   };
   const handleDrawer = () => {
      setOpen(!open);
   };
   const handleCollapsClick = (id) => {
      setMyCollapse(
         myCollapse.map((item) =>
            item.id === id ? { ...item, open: !item.open } : item,
         ),
      );
   };
   const renderBreadcrumbs = () => {
      const pathnames = location.pathname.split('/').filter((x) => x);
      return (
         <Breadcrumbs aria-label='breadcrumb'>
            {pathnames.map((value, idx) => {
               const last = idx === pathnames.length - 1;
               return last ? (
                  <Typography
                     color='Primary'
                     key={value}
                     style={{ textTransform: 'capitalize' }}
                  >
                     {value}
                  </Typography>
               ) : (
                  <Typography
                     color='inherit'
                     key={value}
                     style={{ textTransform: 'capitalize' }}
                  >
                     {value}
                  </Typography>
               );
            })}
         </Breadcrumbs>
      );
   };

   const { oktaAuth } = useOktaAuth();

   const handleLogout = async () => {
      sessionStorage.clear();
      localStorage.clear();
      await oktaAuth.signOut();
   };

   const handleClose = () => {
      setDialog(false);
      history.push('/private/main');
   };

   if (!sideMenu) {
      return <Loading styles={'dashboard'} />;
   }

   return (
      <div className={classes.root}>
         <Dialog
            handleClose={handleClose}
            open={dialog}
            title='ไม่มีสิทธิ์ในการเข้าถึง'
            content='โปรดติดต่อ Admin เพื่อขออนุญาติการเข้าถึง'
            buttonLabel='กลับหน้าหลัก'
            variant='error'
         />
         {/*<CssBaseline />*/}
         <AppBar
            position='fixed'
            className={clsx(classes.appBar, {
               [classes.appBarShift]: open,
            })}
         >
            <Toolbar className={classes.menuBar}>
               <Box
                  display='flex'
                  justifyContent='center'
                  alignContent='center'
                  alignItems='center'
               >
                  <IconButton
                     color='inherit'
                     aria-label='open drawer'
                     onClick={handleDrawer}
                     edge='start'
                     className={clsx(classes.menuButton)}
                  >
                     <FontAwesomeIcon
                        icon={open ? faChevronSquareLeft : faBars}
                     />
                  </IconButton>
                  <Typography variant='h6' noWrap>
                     GSB Way Point
                  </Typography>
               </Box>
               <Box
                  display='flex'
                  justifyContent='center'
                  alignContent='center'
                  alignItems='center'
               >
                  <DarkModeToggle
                     onChange={onToggleDark}
                     checked={theme.palette.type === 'light' ? false : true}
                     size={50}
                  />
                  <IconButton
                     color='inherit'
                     aria-label='open drawer'
                     onClick={handleMyMenuClick}
                     edge='end'
                  >
                     <FontAwesomeIcon icon={faCog} />
                  </IconButton>
                  <Menu
                     id='simple-menu'
                     anchorEl={myMenu}
                     keepMounted
                     open={Boolean(myMenu)}
                     onClose={handleMyMenuClose}
                  >
                     <MenuItem disableRipple>
                        <ListItemIcon>
                           <FontAwesomeIcon
                              icon={faUser}
                              color={Layout.primary}
                           />
                        </ListItemIcon>
                        <ListItemText
                           primary={`${info && info.firstNameTh} ${
                              info && info.lastNameTh
                           }`}
                           style={{ textAlign: 'right' }}
                        />
                     </MenuItem>
                     <MenuItem onClick={handleLogout}>
                        <ListItemIcon>
                           <FontAwesomeIcon
                              icon={faSignOutAlt}
                              color={Layout.primary}
                           />
                        </ListItemIcon>
                        <ListItemText
                           primary={'ออกจากระบบ'}
                           style={{ textAlign: 'right' }}
                        />
                     </MenuItem>
                  </Menu>
               </Box>
            </Toolbar>
         </AppBar>
         <Drawer
            className={classes.drawer}
            variant='persistent'
            anchor='left'
            open={open}
            classes={{
               paper: classes.drawerPaper,
            }}
         >
            <div className={classes.drawerHeader}>
               <div>
                  <Typography variant='h6'>
                     {info && info.firstNameTh}
                  </Typography>
               </div>
               <div>
                  <Typography variant='h6'>
                     {info && info.lastNameTh}
                  </Typography>
               </div>
            </div>
            <Divider />
            <List component='nav'>
               {sideMenu.map((value, idx) => {
                  return value.subPath.length !== 0 ? (
                     <Fragment key={value.path}>
                        <ListItem
                           button
                           onClick={() => handleCollapsClick(value.id)}
                        >
                           <ListItemIcon>
                              <FontAwesomeIcon
                                 icon={
                                    value.id === 'main-01'
                                       ? faAnalytics
                                       : myCollapse.find(
                                            (item) => item.id === value.id,
                                         ).open
                                       ? faFolderOpen
                                       : faFolder
                                 }
                                 color={Layout.primary}
                              />
                           </ListItemIcon>
                           <ListItemText primary={value.name} />
                           <FontAwesomeIcon
                              icon={
                                 myCollapse.find((item) => item.id === value.id)
                                    .open
                                    ? faAngleUp
                                    : faAngleDown
                              }
                              color={Layout.primary}
                           />
                        </ListItem>
                        <Collapse
                           in={
                              myCollapse.find((item) => item.id === value.id)
                                 .open
                           }
                           timeout='auto'
                           unmountOnExit
                        >
                           {value.subPath.map((subValue, idx) => {
                              return (
                                 <List
                                    component='div'
                                    disablePadding
                                    key={subValue.path}
                                 >
                                    <ListItem
                                       button
                                       className={classes.nested}
                                       {...{ to: `/private${subValue.path}` }}
                                       component={Link}
                                       selected={
                                          location.pathname ==
                                          `/private${subValue.path}`
                                             ? true
                                             : false
                                       }
                                       classes={{ selected: classes.active }}
                                    >
                                       <ListItemIcon>
                                          <FontAwesomeIcon
                                             icon={faMinus}
                                             color={Layout.primary}
                                          />
                                       </ListItemIcon>
                                       <ListItemText primary={subValue.name} />
                                    </ListItem>
                                 </List>
                              );
                           })}
                        </Collapse>
                     </Fragment>
                  ) : (
                     <ListItem
                        button
                        key={idx}
                        {...{ to: `/private${value.path}` }}
                        component={Link}
                        selected={
                           location.pathname == `/private${value.path}`
                              ? true
                              : false
                        }
                        classes={{ selected: classes.active }}
                     >
                        <ListItemIcon>
                           <FontAwesomeIcon
                              icon={setIcon(value.id)}
                              color={Layout.primary}
                           />
                        </ListItemIcon>
                        <ListItemText primary={value.name} />
                     </ListItem>
                  );
               })}
            </List>
         </Drawer>
         <Box className={classes.mainContent}>
            <main
               className={clsx(classes.content, {
                  [classes.contentShift]: open,
               })}
            >
               <div className={classes.drawerHeader2} />
               {renderBreadcrumbs()}
               {props.children}
            </main>
            <footer
               className={clsx(classes.footer, {
                  [classes.footerShift]: open,
               })}
            >
               <Copyright />
            </footer>
         </Box>
      </div>
   );
};
export default MainLayout;
